import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionId", "actionMetadata", "getHeaderTitle"];
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import AlterListMembershipActionSummary from 'automation-ui-action-features/actions/alter-list-membership/AlterListMembershipActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
const AlterListMembershipActionCard = _ref => {
  let {
      actionId,
      actionMetadata,
      getHeaderTitle
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, restProps, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: /*#__PURE__*/_jsx(AlterListMembershipActionSummary, {
      actionMetadata: actionMetadata
    })
  }));
};
export default AlterListMembershipActionCard;